import styled from 'styled-components';

export const CardContainer = styled.div`
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 16px;
  margin: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;
export const CardTitle = styled.h2`
  font-size: 1.2em;
  margin-bottom: 8px;
`;

export const CardKey = styled.p`
  font-size: 1em;
  font-weight: bolder;
`;
export const CardValue = styled.p`
  font-size: 1em;
`;
